
import React from 'react';
import { Button } from "@/components/ui/button";
import { AlertCircle } from 'lucide-react';
import CommentSorter from './CommentSorter';
import { SortOption } from '@/components/reader-home/types';

interface CommentsHeaderProps {
  commentCount: number;
  hasFilters: boolean;
  filterCount: number;
  sortOption: SortOption;
  onSortChange: (option: SortOption) => void;
  onToggleGuidelines: () => void;
}

const CommentsHeader: React.FC<CommentsHeaderProps> = ({
  commentCount,
  hasFilters,
  filterCount,
  sortOption,
  onSortChange,
  onToggleGuidelines
}) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <h3 className="text-xl font-bold">
        Discussion ({commentCount})
        {hasFilters && (
          <span className="text-sm font-normal text-muted-foreground ml-2">
            Filtered by {filterCount} {filterCount === 1 ? 'topic' : 'topics'}
          </span>
        )}
      </h3>
      <div className="flex items-center gap-2">
        <Button 
          variant="outline" 
          size="sm" 
          className="text-xs"
          onClick={onToggleGuidelines}
        >
          <AlertCircle className="h-3 w-3 mr-1" />
          Guidelines
        </Button>
        <CommentSorter 
          sortOption={sortOption} 
          onSortChange={onSortChange} 
        />
      </div>
    </div>
  );
};

export default CommentsHeader;
